import { SOCIAL_MEDIA } from "rivals/shared/constants";
import { Config } from "./types";

const socialMediaConfigs: { [key in SOCIAL_MEDIA]: Config } = {
  [SOCIAL_MEDIA.FACEBOOK]: {
    icon: "/static/icons/icons_FacebookCircle.svg",
    shareUrl: "https://www.facebook.com/sharer/sharer.php?u="
  },
  [SOCIAL_MEDIA.REDDIT]: {
    icon: "/static/icons/icons_reddit_button.svg",
    shareUrl: "http://www.reddit.com/submit?url="
  },
  [SOCIAL_MEDIA.TWITTER]: {
    icon: "",
    shareUrl: "https://twitter.com/intent/tweet?url="
  }
};

export default {
  configs: socialMediaConfigs,
  dimensions: "height=300,width=600",
  newWindow: "new-window",
  philter: "social-media-share-icon"
};
